export default "__VITE_ASSET__e3dcb14a__"